<template>
  <div class="" style="text-align: left;background-color:white;">
    <div class="container">
      <div class="inside_header_box">
        <div
          class="container-sm sectionKoko"
          style="background-color:#F3EEE7;border-radius: 40px;"
        >
          <div class="row mt-5">
            <div class="col-md-8 col-sm-12 mt-12" style="text-align: left">
              <img
                src="https://img.alicdn.com/imgextra/i4/O1CN01T5poCT1Y6AUtJ5WpB_!!6000000003009-2-tps-1080-1080.png"
                alt="“hero”"
                style="max-width:28%;float: right;margin-top: -15%;"
              />
              <div class="headerbox">
                <div class="headerbox_body">
                  <div class="sectionHead">
                    Shop now, pay <b style="color:#021FA3">later</b> with Koko.
                  </div>
                  <!-- <div class="sectionBody" style="width:83%;">
                    Interest free instalments with a debit card.
                    <b>Get 10% OFF </b> on your first purchase!
                  </div> -->
                  <a href="https://bit.ly/merchantDownloadKoko">
                    <div
                      class="btn kokoWebButtons mt-2"
                      style="width: 200px; position: relative;border-radius:16px;"
                    >
                      <span
                        class="center"
                        style="color: #ffffff; font-size: 14px; font-weight: bold"
                      >
                        Download App
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 align-middle text-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sectionKoko2"
      style="background-color: white;margin-left: 5%;margin-right: 5%;"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-8 col-sm-12 mt-12" style="text-align: left">
            <div class="sectionIntro">
              <div class="sectionHead">What is Koko?</div>
              <div class="sectionBody">
                Koko is a<b>‘Buy Now, Pay Later’</b> app that lets you buy what
                you love today & pay for it in
                <b>3 interest free instalments </b> with a <b> debit card </b> .
              </div>

              <div class="sectionBody">
                The first instalment gets deducted from your card at the time of
                purchase. The remaining instalments get deducted every 30 days.
                And that’s not all, the total order value does not get blocked
                from your card! How cool is that?
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 mt-12" style="text-align: left">
            <img
              src="https://img.alicdn.com/imgextra/i2/O1CN01ia1AiW27iBvpNJiQs_!!6000000007830-2-tps-3000-3000.png"
              alt="“hero”"
              class="header_imge"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pc">
      <div
        class="sectionKoko2"
        style="background-color: white;margin-left: 5%;margin-right: 5%;"
      >
        <div class="container">
          <div class="row mt-5" style="text-align: center">
            <div class="sectionHead" style="text-align: left;">
              How to get started?
            </div>
            <div class="col">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i4/O1CN01baWo6i1xDN7czo83N_!!6000000006409-2-tps-3000-3000.png"
                  alt="“quick-start”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Download the App</div>
                <div class="iconExpBody">
                  Download the Koko App on the Apple App Store or Google Play
                  Store.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i3/O1CN01q2bLlj27Wk1zjUr84_!!6000000007805-2-tps-3000-3000.png"
                  alt="“new-customer”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Register your account</div>
                <div class="iconExpBody">
                  Register your Koko account in a few simple steps.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i4/O1CN01yUkUVv1JxYQjH5l8P_!!6000000001095-2-tps-3000-3000.png"
                  alt="“support”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Add your card</div>
                <div class="iconExpBody">
                  Add your debit or credit card to the My Koko section of the
                  App .
                </div>
              </div>
            </div>
            <div class="col">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i2/O1CN01NzxOWe1hTN6eZ1Dkx_!!6000000004278-2-tps-400-400.png"
                  alt="“fraud”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Receive limit</div>
                <div class="iconExpBody">
                  Check your credit limit. This is how much you can spend with
                  Koko.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i2/O1CN013u4U5w1sVAQhYFaGw_!!6000000005771-2-tps-3000-3000.png"
                  alt="“power”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Pay with Koko</div>
                <div class="iconExpBody">
                  Add your favorite products to cart & simply choose Koko as the
                  payment method at checkout.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div
        class="sectionKoko2"
        style="background-color: white;margin-left: 5%;margin-right: 5%;"
      >
        <div class="container">
          <div class="row mt-5" style="text-align: center">
            <div class="sectionHead" style="text-align: left;">
              How to get started?
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i4/O1CN01baWo6i1xDN7czo83N_!!6000000006409-2-tps-3000-3000.png"
                  alt="“quick-start”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Download the App</div>
                <div class="iconExpBody">
                  Download the Koko App on the Apple App Store or Google Play
                  Store.
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i3/O1CN01q2bLlj27Wk1zjUr84_!!6000000007805-2-tps-3000-3000.png"
                  alt="“new-customer”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Register your account</div>
                <div class="iconExpBody">
                  Register your Koko account in a few simple steps.
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i4/O1CN01yUkUVv1JxYQjH5l8P_!!6000000001095-2-tps-3000-3000.png"
                  alt="“support”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Add your card</div>
                <div class="iconExpBody">
                  Add your debit or credit card to the My Koko section of the
                  App .
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i2/O1CN01NzxOWe1hTN6eZ1Dkx_!!6000000004278-2-tps-400-400.png"
                  alt="“fraud”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Receive limit</div>
                <div class="iconExpBody">
                  Check your credit limit. This is how much you can spend with
                  Koko.
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
              <div class="maxWidthDefiner">
                <img
                  src="https://img.alicdn.com/imgextra/i2/O1CN013u4U5w1sVAQhYFaGw_!!6000000005771-2-tps-3000-3000.png"
                  alt="“power”"
                  style="width:60%"
                /><br />
                <div class="iconExpHead">Pay with Koko</div>
                <div class="iconExpBody">
                  Add your favorite products to cart & simply choose Koko as the
                  payment method at checkout.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sectionKoko2"
      style="background-color: white;margin-left:5%;margin-right:5%;margin-top:5%;"
    >
      <div class="container" style="padding-top: 40px; max-width: 800px">
        <div class="row">
          <div class="col-sm-6" style="text-align: center">
            <img
              src="https://img.alicdn.com/imgextra/i4/O1CN01QJyxlK1KJzpu7i6lI_!!6000000001144-2-tps-1235-2410.png"
              alt="portrait-phone"
              style="width: 80%; max-width: 350px; margin-top: -50px"
            />
          </div>
          <div class="col-sm-6">
            <div class="sectionHead mt-5">Koko’s Tips:</div>
            <div class="sectionBody">
              <div class="iconExpHead">Increase your credit limit</div>
              <div class="sectionBody">
                Upon registration, Koko shall grant you an instant credit limit.
                To increase chances to a higher credit limit, you can upload
                your NIC, most recent salary slip, & the latest utility bill on
                to the My Koko section of the App & receive a limit of up to LKR
                200,000!
              </div>

              <div class="iconExpHead" style="margin-top: 5%;">
                Pay back on time
              </div>
              <div class="sectionBody">
                Koko understands if you need more time to pay. Koko is
                completely free if you pay your instalments back on time. You
                are entitled to two free payment reschedules every year. For any
                late payments, you will be charged LKR 1,500 as a late payment
                fee.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="sectionKoko2"
      style="background-color: white;margin-left: 5%;margin-right: 5%;"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6 col-sm-12 mt-12" style="text-align: left">
            <div class="d-block d-sm-none">
              <img
                src="https://img.alicdn.com/imgextra/i4/O1CN01T5poCT1Y6AUtJ5WpB_!!6000000003009-2-tps-1080-1080.png"
                alt="“hero”"
                style="max-width: 37%;float: right;margin-top: -20%;margin-right: 10px;"
              />
            </div>
            <div class="sectionIntro">
              <div class="sectionHead">Support</div>
              <div class="sectionBody">
                Koko’s always got your back. If you require any support, please
                holla at Koko via <b>hello@paykoko.com </b> and for more
                information you may visit our website at http://paykoko.com
              </div>
              <div class="sectionBody">
                <b>Split it in 3, interest free! </b>
              </div>
              <div class="sectionBody">
                Don’t forget to follow us on social media.
              </div>
            </div>
          </div>

          <div class="col-md-6 col-sm-12 mt-12" style="text-align: left">
            <!-- <img
              src="https://img.alicdn.com/imgextra/i2/O1CN01iFSMeF1xiW3Up3CpN_!!6000000006477-2-tps-3000-3000.png"
              alt="“hero”"
              style="max-width:60%;margin-top: -10%;"
            /> -->
          </div>
        </div>
        <div class="row row-cols-auto mt-4">
          <div class="col">
            <a href="https://www.facebook.com/paykokoapp">
              <img
                src="https://img.alicdn.com/imgextra/i3/O1CN01islRtB1hcX1nlqwJk_!!6000000004298-2-tps-1000-1000.png"
                width="40"
                alt="facebook"
              />
            </a>
          </div>
          <div class="col">
            <a href="https://www.instagram.com/paykokoapp/">
              <img
                src="https://img.alicdn.com/imgextra/i1/O1CN01Kba5NH21JYwK12Cfw_!!6000000006964-2-tps-1000-1000.png"
                width="40"
                alt="instagram"
              />
            </a>
          </div>
          <div class="col">
            <a href="https://twitter.com/paykokoapp">
              <img
                src="https://img.alicdn.com/imgextra/i1/O1CN0196aAPy1U7lPotqhhu_!!6000000002471-2-tps-1000-1000.png"
                width="40"
              />
            </a>
          </div>
          <div class="col">
            <a href="https://www.youtube.com/channel/UCkjFKyiupLUsDI94_R1Xt_w">
              <img
                src="https://img.alicdn.com/imgextra/i3/O1CN01DA4IQt1VZzRIvxRtZ_!!6000000002668-2-tps-1000-1000.png"
                width="40"
              />
            </a>
          </div>
          <div class="col">
            <a href="https://www.linkedin.com/company/paykokoapp">
              <img
                src="https://img.alicdn.com/imgextra/i1/O1CN01sgEaMf1IIxi8aBZkb_!!6000000000871-2-tps-1000-1000.png"
                width="40"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IframeEducation",
  components: {},
};
</script>

<style scoped>
.body_class {
  background-color: white;
}
.div#app {
  background-color: white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;
  text-align: justify;
  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}
.sectionKoko2 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

.bigSpecImgHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  /* line-height: 29px; */

  color: #393939;
}

.zcwf_col_lab {
  color: #393939;
  opacity: 0.8;
}

.maxWidthDefiner {
  /*max-width: 250px;*/
  margin-top: 30px;
}

.maxWidthDefiner3 {
  max-width: 300px;
  margin-top: 30px;
}

.kokoWebButtons {
  background-color: #000000;
  border: 0;
  height: 40px;
  width: 300px;
  font-weight: bold;
}

.headerbox {
  background-color: white;
  border-radius: 16px;
  width: 90%;
  margin-left: 5%;
  height: 220px;
  margin-top: 5%;
}
.headerbox_body {
  margin-left: 5%;
  padding-top: 5%;
  height: 450px;
  margin-right: 5%;
}
.mobile {
  display: none;
}
.header_imge {
  max-width: 137%;
  margin-top: -24%;
  margin-left: -70%;
}

@media only screen and (max-width: 600px) {
  .headerbox {
    background-color: white;
    border-radius: 16px;
    width: 90%;
    margin-left: 5%;
    height: 330px;
  }
  .mobile {
    display: block;
  }

  .pc {
    display: none;
  }
  .header_imge {
    max-width: 100%;
    margin-top: -10%;
    margin-left: -6%;
  }
}
</style>
